import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { OpenCustomAlerts } from 'store/slices/commonSlice'
import config from "../config";

const CustomAlerts = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [errorsCustoms, setErrorsCustoms] = useState([]);
    const isOpenCustomAlerts = useSelector((state) => state.common.isOpenCustomAlerts);
    const customAlertErrors = useSelector((state) => state.common.customAlertErrors);
    useEffect(() => {
        if (
            customAlertErrors &&
            customAlertErrors.props &&
            customAlertErrors.props.children &&
            Array.isArray(customAlertErrors.props.children) &&
            customAlertErrors?.props?.children?.length > 0
        ) {
            setErrorsCustoms(customAlertErrors.props.children);
        } else {
            setErrorsCustoms([]);
        }
    }, [customAlertErrors]);
    return (
        <>
            <div className={isOpenCustomAlerts === "open" ? "modal fade show" : "modal fade"} id="add-emailverification" tabIndex="-1" aria-labelledby="addemailverificationModalLabel" style={{ display: isOpenCustomAlerts === "open" ? "block" : "none" }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content ">
                        <div className="modal-body pb-0">
                            <div className="p-3">
                                {/* <h5 className="mb-3 fw-semibold text-dark">{t("Error While Submit.")}</h5> */}
                                <div className='row'>
                                    <div className="col-12 custom-alerts-popups">
                                        {errorsCustoms.map((element, index) => (
                                            <ul key={index} style={{ listStyle: 'none',paddingLeft:"0px" }}>
                                                <li>{element?.props?.children}</li>
                                            </ul>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-3 bg-cream p-4 justify-content-center">
                                <div className="col-6">
                                    <button className="btn btn-primary w-100" type="submit" onClick={() => { dispatch(OpenCustomAlerts("")) }}>
                                        {t("OK")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isOpenCustomAlerts === "open" && <div className="modal-backdrop show"></div>}
        </>
    )
}

export default CustomAlerts;